import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import { useAppIdBySlug } from '@hooks/sample-requests/useAppIdBySlug';

export const SampleRequest = () => {
  const slug = 'gobrendajulho';
  const { data } = useAppIdBySlug(slug);

  return (
    <Box>
      <Card sx={{ py: 2, px: 6 }}>
        <Grid container>
          <Grid item xs={12}>
            <Typography align="center" variant="h5" gutterBottom>
              Requisição
            </Typography>
            <hr />
            <Typography component="div">
              <Box fontWeight="bold">
                <Typography align="center" gutterBottom>
                  Retornando o ID do app através do Slug:{' '}
                  <Box component="span" sx={{ fontStyle: 'italic' }}>
                    {'gobrendajulho'}
                  </Box>
                </Typography>
                <Divider />
                <Box fontWeight="normal" display="inline">
                  <Typography
                    sx={{ mr: 1, display: 'inline' }}
                    variant="subtitle1"
                    fontWeight="bold"
                    color="text.primary"
                  >
                    ID:
                  </Typography>
                  <Typography variant="subtitle2" color="text.secondary" sx={{ display: 'inline' }}>
                    {data?.id}
                  </Typography>
                </Box>
              </Box>
            </Typography>
          </Grid>
        </Grid>
      </Card>
    </Box>
  );
};
